import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-810346e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-h6" }
const _hoisted_2 = {
  key: 0,
  class: "inquiry-context px-4 py-3"
}
const _hoisted_3 = {
  class: "d-flex flex-wrap align-center",
  style: {"gap":"8px"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-caption text-medium-emphasis mr-1" }, "Az igény:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, "Érkezés", -1))
const _hoisted_6 = {
  key: 0,
  class: "validation-error"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-label" }, "Távozás", -1))
const _hoisted_8 = {
  key: 0,
  class: "validation-error"
}
const _hoisted_9 = {
  class: "d-flex align-center flex-wrap",
  style: {"gap":"12px"}
}
const _hoisted_10 = {
  key: 0,
  class: "line-preview text-body-2"
}
const _hoisted_11 = { class: "text-medium-emphasis" }
const _hoisted_12 = { class: "font-weight-medium" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-medium-emphasis" }, " · árrés ", -1))
const _hoisted_14 = {
  key: 0,
  class: "text-caption text-medium-emphasis mr-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_AddOfferTable = _resolveComponent("AddOfferTable")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_btn, {
      class: "dialog-open-btn",
      color: "primary",
      variant: "outlined",
      "prepend-icon": "mdi-plus",
      onClick: _ctx.handeCreateOfferClicked
    }, {
      default: _withCtx(() => [
        _createTextVNode("Új ajánlat összeállítása")
      ]),
      _: 1
    }, 8, ["onClick"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showAddOfferDialog,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showAddOfferDialog) = $event)),
      "max-width": "1200",
      fullscreen: _ctx.smAndDown,
      scrollable: true,
      persistent: true,
      "no-click-animation": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "new-item-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex align-center py-3" }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.isEditing ? "Piszkozat szerkesztése" : "Új ajánlat összeállítása"), 1),
                _createVNode(_component_v_chip, {
                  class: "ml-3",
                  size: "small",
                  color: "warning",
                  variant: "flat",
                  label: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("piszkozat")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  variant: "text",
                  density: "comfortable",
                  onClick: _ctx.handleCloseClicked
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            (_ctx.inquiry)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    (_ctx.inquiry.publicReference)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          size: "small",
                          variant: "tonal",
                          "prepend-icon": "mdi-pound"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.formatPublicReference(_ctx.inquiry.publicReference)), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.inquiry.area)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 1,
                          size: "small",
                          variant: "tonal",
                          "prepend-icon": "mdi-map-marker"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.inquiry.area), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.inquiryPeriodLabel)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 2,
                          size: "small",
                          variant: "tonal",
                          "prepend-icon": "mdi-calendar-range"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.inquiryPeriodLabel), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.inquiry.numberOfPeople)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 3,
                          size: "small",
                          variant: "tonal",
                          "prepend-icon": "mdi-account-group"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.inquiry.numberOfPeople) + " fő", 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.inquiry.placementType)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 4,
                          size: "small",
                          variant: "tonal",
                          "prepend-icon": "mdi-bed-outline"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.placementTypeLabel(_ctx.inquiry.placementType)), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.inquiry.catering)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 5,
                          size: "small",
                          variant: "tonal",
                          "prepend-icon": "mdi-silverware-fork-knife"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.inquiry.catering), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.inquiry)
              ? (_openBlock(), _createBlock(_component_v_divider, { key: 1 }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panels, {
                  class: "mb-4",
                  modelValue: _ctx.openPanels,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.openPanels) = $event)),
                  variant: "accordion",
                  multiple: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              class: "mr-2",
                              icon: _ctx.editingIndex === null ? 'mdi-plus-box-outline' : 'mdi-pencil-outline',
                              size: "small"
                            }, null, 8, ["icon"]),
                            _createTextVNode(_toDisplayString(_ctx.editingIndex === null ? "Tétel hozzáadása" : `${_ctx.editingIndex + 1}. tétel szerkesztése`), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_combobox, {
                                      modelValue: _ctx.v$.accommodation.$model,
                                      "onUpdate:modelValue": [
                                        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.accommodation.$model) = $event)),
                                        _ctx.handleAccommodationsComboboxChange
                                      ],
                                      "error-messages": _ctx.v$.accommodation.$errors.map(error => error.$message),
                                      items: _ctx.allAccommodations.map((accommodation)=> accommodation.name),
                                      label: "Szálláshely",
                                      loading: _ctx.accommodationsLoading,
                                      variant: "outlined",
                                      density: "comfortable"
                                    }, null, 8, ["modelValue", "error-messages", "items", "loading", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_combobox, {
                                      modelValue: _ctx.v$.product.$model,
                                      "onUpdate:modelValue": [
                                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.product.$model) = $event)),
                                        _ctx.handleProductsComboboxChange
                                      ],
                                      "error-messages": _ctx.v$.product.$errors.map(error => error.$message),
                                      items: _ctx.productsForSelectedAccommodation.map((product)=> product.name),
                                      label: "Termék",
                                      variant: "outlined",
                                      density: "comfortable"
                                    }, null, 8, ["modelValue", "error-messages", "items", "onUpdate:modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _ctx.v$.city.$model,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.city.$model) = $event)),
                                      "error-messages": _ctx.v$.city.$errors.map(error => error.$message),
                                      label: "Város",
                                      variant: "outlined",
                                      density: "comfortable"
                                    }, null, 8, ["modelValue", "error-messages"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: _ctx.v$.address.$model,
                                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.address.$model) = $event)),
                                      "error-messages": _ctx.v$.address.$errors.map(error => error.$message),
                                      label: "Cím",
                                      variant: "outlined",
                                      density: "comfortable"
                                    }, null, 8, ["modelValue", "error-messages"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_5,
                                    _createVNode(_component_Datepicker, {
                                      teleport: true,
                                      modelValue: _ctx.v$.from.$model,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.v$.from.$model) = $event)),
                                      "enable-time-picker": false,
                                      "auto-apply": true,
                                      format: 'yyyy-MM-dd',
                                      state: _ctx.v$.from.$errors.length == 0,
                                      clearable: false,
                                      locale: "hu"
                                    }, null, 8, ["modelValue", "state"]),
                                    (_ctx.v$.from.$errors.length != 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.v$.from.$errors[0].$message), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_7,
                                    _createVNode(_component_Datepicker, {
                                      teleport: true,
                                      modelValue: _ctx.v$.to.$model,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.v$.to.$model) = $event)),
                                      "enable-time-picker": false,
                                      "auto-apply": true,
                                      format: 'yyyy-MM-dd',
                                      state: _ctx.v$.to.$errors.length == 0,
                                      clearable: false,
                                      "min-date": _ctx.toMinDate,
                                      locale: "hu"
                                    }, null, 8, ["modelValue", "state", "min-date"]),
                                    (_ctx.v$.to.$errors.length != 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.v$.to.$errors[0].$message), 1))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "4"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Létszám",
                                      modelValue: _ctx.v$.numberOfPeople.$model,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.v$.numberOfPeople.$model) = $event)),
                                      "error-messages": _ctx.v$.numberOfPeople.$errors.map(error => error.$message),
                                      type: "number",
                                      variant: "outlined",
                                      density: "comfortable",
                                      "hide-spin-buttons": "",
                                      suffix: "fő"
                                    }, null, 8, ["modelValue", "error-messages"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, { dense: "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Bejövő bruttó ár /fő/éj",
                                      modelValue: _ctx.v$.grossPricePerPersonPerNight.$model,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.v$.grossPricePerPersonPerNight.$model) = $event)),
                                      "error-messages": _ctx.v$.grossPricePerPersonPerNight.$errors.map(error => error.$message),
                                      type: "number",
                                      variant: "outlined",
                                      density: "comfortable",
                                      "hide-spin-buttons": "",
                                      suffix: "Ft"
                                    }, null, 8, ["modelValue", "error-messages"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  sm: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Kimenő nettó ár /fő/éj",
                                      modelValue: _ctx.v$.retailPrice.$model,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.v$.retailPrice.$model) = $event)),
                                      "error-messages": _ctx.v$.retailPrice.$errors.map(error => error.$message),
                                      type: "number",
                                      variant: "outlined",
                                      density: "comfortable",
                                      "hide-spin-buttons": "",
                                      suffix: "Ft"
                                    }, null, 8, ["modelValue", "error-messages"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.dateMismatchWarning)
                              ? (_openBlock(), _createBlock(_component_v_alert, {
                                  key: 0,
                                  class: "mb-3",
                                  type: "info",
                                  variant: "tonal",
                                  density: "compact"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.dateMismatchWarning), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_9, [
                              (_ctx.linePreview)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.linePreview.calculation) + " = ", 1),
                                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.linePreview.revenue), 1),
                                    _hoisted_13,
                                    _createElementVNode("span", {
                                      class: _normalizeClass(_ctx.linePreview.marginPositive ? 'text-success font-weight-medium' : 'text-error font-weight-medium')
                                    }, _toDisplayString(_ctx.linePreview.margin), 3)
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_spacer),
                              (_ctx.editingIndex !== null)
                                ? (_openBlock(), _createBlock(_component_v_btn, {
                                    key: 1,
                                    variant: "text",
                                    onClick: _ctx.cancelEdit
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Mégse")
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_btn, {
                                color: "primary",
                                variant: "flat",
                                "prepend-icon": _ctx.editingIndex === null ? 'mdi-plus' : 'mdi-check',
                                onClick: _ctx.addItem
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.editingIndex === null ? "Tétel hozzáadása" : "Módosítás mentése"), 1)
                                ]),
                                _: 1
                              }, 8, ["prepend-icon", "onClick"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_AddOfferTable, {
                  items: _ctx.items,
                  onRemoveItem: _ctx.removeItem,
                  onEditItem: _ctx.startEdit
                }, null, 8, ["items", "onRemoveItem", "onEditItem"]),
                (_ctx.hasPendingLine)
                  ? (_openBlock(), _createBlock(_component_v_alert, {
                      key: 0,
                      class: "mt-4",
                      type: "warning",
                      variant: "tonal",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Van megkezdett tétel az űrlapon, amit még nem adott hozzá az ajánlathoz. A mentés csak a listában szereplő tételeket menti.")
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_row, { class: "mt-2" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          class: "mb-2",
                          label: "Lemondási feltétel sablon",
                          variant: "outlined",
                          density: "comfortable",
                          "hide-details": "",
                          items: _ctx.cancellationPolicyPresets,
                          "item-title": "title",
                          "item-value": "title",
                          "model-value": null,
                          placeholder: "Válasszon sablont…",
                          "onUpdate:modelValue": _ctx.applyCancellationPolicyPreset
                        }, null, 8, ["items", "onUpdate:modelValue"]),
                        _createVNode(_component_v_textarea, {
                          modelValue: _ctx.cancellationPolicy,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.cancellationPolicy) = $event)),
                          label: "Lemondási feltételek *",
                          variant: "outlined",
                          rows: "5",
                          "error-messages": _ctx.cancellationPolicyError,
                          hint: "Az ügyfél is látja az ajánlatnál.",
                          "persistent-hint": ""
                        }, null, 8, ["modelValue", "error-messages"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "12",
                      md: "6"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_textarea, {
                          class: "comment-textarea",
                          modelValue: _ctx.comment,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.comment) = $event)),
                          label: "Megjegyzés",
                          variant: "outlined",
                          rows: "5",
                          hint: "Az ügyfél is látja az ajánlatnál.",
                          "persistent-hint": ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_actions, { class: "px-4 py-3" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _ctx.handleCloseClicked
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Vissza")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_spacer),
                (_ctx.submitBlockedReason)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.submitBlockedReason), 1))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_btn, {
                  color: "warning",
                  variant: "elevated",
                  "prepend-icon": "mdi-content-save-outline",
                  loading: _ctx.submitting,
                  disabled: _ctx.submitting,
                  onClick: _ctx.submitOffer
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isEditing ? "Módosítások mentése" : "Piszkozat mentése"), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "fullscreen"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.showDiscardConfirm,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.showDiscardConfirm) = $event)),
      "max-width": "460"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isEditing ? "Módosítások elvetése" : "Ajánlat elvetése"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.isEditing ? "A piszkozaton végzett módosítások nincsenek elmentve, és elvesznek. Biztosan bezárja?" : "A megkezdett ajánlat nincs elmentve, és elveszik. Biztosan bezárja?"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showDiscardConfirm = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Mégse")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "error",
                  variant: "flat",
                  onClick: _ctx.confirmDiscard
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Igen, elvetem")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}